module.exports = __webpack_public_path__ + "img/hero_landlord_mobile.a13c3efd.png";